import { Component, OnInit } from '@angular/core';
import {MdDialog, MdDialogRef} from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-add-subcategory',
  templateUrl: './add-subcategory.component.html',
  styleUrls: ['./add-subcategory.component.css']
})
export class AddSubcategoryComponent implements OnInit {
	complexForm : FormGroup;
	name;
  	constructor(public dialogRef: MdDialogRef <AddSubcategoryComponent>, fb: FormBuilder) { 
  		this.complexForm = fb.group({
	      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.
	      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.
	      'name': [null, Validators.compose([Validators.required, Validators.minLength(2), this.NoWhitespaceValidator, this.AlphanumericValidator])],
	    })
	}

  ngOnInit() {
  }

  saveData() {
  		console.log('this.name', this.name)
	    this.dialogRef.close(this.name);
	}

  public NoWhitespaceValidator(control: FormControl) {
		if (/\s/.test(control.value)) {
		    // It has any kind of whitespace
		    return { 'whitespace': true };
		}
		else{
			return null;
		}
	}

	public AlphanumericValidator(control: FormControl) {
		if (/^[\w\-\s]+$/.test(control.value)) {
		    // It contains other characters than letters and numbers
		    return null;
		}
		else{
			return { 'alphanumeric': true };
		}
	}

}



// WEBPACK FOOTER //
// d:/xampp/htdocs/zenith-admin/src/app/add-subcategory/add-subcategory.component.ts